import { useEffect, useState } from "react";
import { Trophy, Timer, Flame } from "lucide-react";
import { staffApi } from "./staffApi";

const fmtMin = (m) => (m == null ? "—" : m >= 60 ? `${Math.floor(m / 60)}h ${m % 60}m` : `${m} min`);

export const ShiftSummary = ({ staff }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    staffApi.get("/staff/shift/summary").then((r) => setData(r.data)).catch(() => setData({ rows: [] }));
  }, []);
  if (!data) return <p className="p-8 text-white/50 text-xl">Counting your tables…</p>;

  const mine = staff ? data.rows.find((r) => r.staff_id === staff.staff_id) : null;
  const isMgr = staff && (staff.role === "manager" || staff.role === "owner");
  const showCrew = !staff || isMgr;

  return (
    <div data-testid="shift-summary" className="p-4 pb-16 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold tracking-tight">Shift summary <span className="text-white/35 text-base font-medium">· last {data.since_hours} hours · no sales shown, just the hustle</span></h2>

      {staff && <div className="grid grid-cols-3 gap-3 mt-5">
        {[
          { icon: Trophy, label: "TABLES SERVED", val: mine?.tables_served ?? 0, color: "#D4AF37", testId: "shift-tables" },
          { icon: Timer, label: "AVG TABLE TIME", val: fmtMin(mine?.avg_table_minutes), color: "#5AB0FF", testId: "shift-avg" },
          { icon: Flame, label: "ACTIVE NOW", val: mine?.active_tables ?? 0, color: "#F59E0B", testId: "shift-active" },
        ].map((c) => (
          <div key={c.label} data-testid={c.testId} className="s-card rounded-2xl p-5 text-center">
            <c.icon size={22} className="mx-auto" style={{ color: c.color }} />
            <p className="num text-5xl font-bold tracking-tighter mt-2" style={{ color: c.color }}>{c.val}</p>
            <p className="text-[11px] uppercase tracking-[0.2em] text-white/45 font-semibold mt-1.5">{c.label}</p>
          </div>
        ))}
      </div>}

      {showCrew && (
        <div className="s-card rounded-2xl mt-5 p-5">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#D4AF37] font-bold">THE WHOLE CREW</p>
          {data.rows.length === 0 && <p className="text-white/40 text-lg mt-3">No tables handled in this window yet.</p>}
          {data.rows.map((r, i) => (
            <div key={r.staff_id} data-testid={`shift-row-${r.staff_id}`} className="flex items-center gap-4 py-3.5 border-b border-white/6 last:border-0">
              <span className="num text-2xl font-bold text-white/30 w-8">{i + 1}</span>
              <p className="flex-1 text-lg font-semibold">{r.name}</p>
              <div className="text-right">
                <p className="num text-2xl font-bold text-[#D4AF37]">{r.tables_served}</p>
                <p className="text-[10px] uppercase tracking-widest text-white/40">tables</p>
              </div>
              <div className="text-right w-24">
                <p className="num text-2xl font-bold text-[#5AB0FF]">{fmtMin(r.avg_table_minutes)}</p>
                <p className="text-[10px] uppercase tracking-widest text-white/40">avg time</p>
              </div>
              <div className="text-right w-16">
                <p className="num text-2xl font-bold text-[#F59E0B]">{r.active_tables}</p>
                <p className="text-[10px] uppercase tracking-widest text-white/40">live</p>
              </div>
            </div>
          ))}
        </div>
      )}
      {staff && !isMgr && !mine && <p className="text-white/40 text-lg mt-6 text-center">No tables handled yet this shift — your first one starts the clock.</p>}
    </div>
  );
};
